import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex justify-center"
}
const _hoisted_2 = { class: "font-semibold text-gray-lp-300 mb-2 text-14px xxl:text-14px" }
const _hoisted_3 = { class: "leading-tight" }
const _hoisted_4 = { class: "text-12px text-gray-lp-800 break-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "modal-v3",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
    modal: "",
    closeOnEscape: "",
    blockScroll: "",
    showHeader: false,
    style: { width: _ctx.customWidth || '380px' }
  }, {
    default: _withCtx(() => [
      _createVNode("div", {
        class: _ctx.isPaddingTopBottom ? 'font-montserrat py-6 flex flex-col' : 'font-montserrat flex flex-col'
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          (_ctx.image)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("img", {
                  src: require(`@/app/ui/assets/svg/${_ctx.image}.svg`),
                  alt: "popup",
                  class: `w-${_ctx.imageWidth} h-${_ctx.imageHeight}`
                }, null, 10, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: ["popup-message text-center", `${_ctx.customTitleMessagePadding}`]
          }, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
                [_directive_sanitize_html, _ctx.title]
              ])
            ]),
            _createVNode("div", _hoisted_3, [
              _withDirectives(_createVNode("span", _hoisted_4, null, 512), [
                [_directive_sanitize_html, _ctx.message]
              ]),
              _renderSlot(_ctx.$slots, "custom")
            ])
          ], 2),
          _createVNode("div", {
            class: ["px-8 items-center mx-auto flex flex-row rounded-b-md text-xs gap-x-4", [
            _ctx.customWrapperButton,
            (_ctx.reverseButton ? _ctx.textSuccess : _ctx.textCancel) ? '' : 'w-full'
          ]]
          }, [
            (_ctx.reverseButton ? _ctx.textSuccess : _ctx.textCancel)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 0,
                  id: _ctx.idButtonSubmit,
                  title: _ctx.reverseButton ? _ctx.textSuccess : _ctx.textCancel,
                  textColor: "red-lp-100",
                  color: "red-lp-100",
                  outline: "",
                  class: _ctx.customParentButton,
                  customClass: _ctx.customButton,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reverseButton ? _ctx.onSubmit() : _ctx.onClose())),
                  fontWeight: _ctx.buttonFontWeight,
                  isWidthFull: _ctx.isButtonFull
                }, null, 8, ["id", "title", "class", "customClass", "fontWeight", "isWidthFull"]))
              : _createCommentVNode("", true),
            (_ctx.isButtonSuccess)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 1,
                  id: _ctx.idButtonSubmit,
                  title: _ctx.reverseButton ? _ctx.textCancel : _ctx.textSuccess,
                  textColor: "white",
                  color: "red-lp-100",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reverseButton ? _ctx.onClose() : _ctx.onSubmit && _ctx.onSubmit())),
                  iconLeft: _ctx.textSuccess == 'Muat ulang' ? 'ics_o_sync_white' : '',
                  disabled: _ctx.isDisabled,
                  class: _ctx.customParentButton,
                  customClass: _ctx.customButton,
                  fontWeight: _ctx.buttonFontWeight,
                  isWidthFull: 
              !(_ctx.reverseButton ? _ctx.textSuccess : _ctx.textCancel) || _ctx.isButtonFull
            
                }, null, 8, ["id", "title", "iconLeft", "disabled", "class", "customClass", "fontWeight", "isWidthFull"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "custom-button")
          ], 2)
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["visible", "style"]))
}